import { render, staticRenderFns } from "./SampleTableActionRender.vue?vue&type=template&id=2daa01e6&"
import script from "./SampleTableActionRender.vue?vue&type=script&lang=ts&"
export * from "./SampleTableActionRender.vue?vue&type=script&lang=ts&"
import style0 from "./SampleTableActionRender.vue?vue&type=style&index=0&id=2daa01e6&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports